import styled from "styled-components";

export const StyledInvoiceWrapper = styled.div`
  display: inline-grid;
  grid-template-rows: 45px;
  button {
    height: 100%;
  }
`;

export const StyledInvoiceAttrInputWrapper = styled.div`
  position: relative;
  label {
    color: ${({theme}) => theme.input.labelColor};
    font-size: 14px;
    transform: translate(0, 1.5px) scale(0.75);
    transform-origin: top left;
  }
  input {
    padding: 5px 0 7px;
    color: ${({theme}) => theme.input.color};
    border: none;
    background-color: transparent;
    border-bottom: 1px solid ${({theme}) => theme.overlay.underline};
    &:hover {
      border-bottom: 1px solid ${({theme}) => theme.overlay.underlineHover};
      box-shadow: 0 1px 0 0 ${({theme}) => theme.overlay.underlineHover};
    }
    &:focus {
      border-bottom: 1px solid ${({theme}) => theme.input.focusUnderline};
    }

    &::-webkit-input-placeholder {
      opacity: 0.35;
    }
    &:-moz-placeholder {
      opacity: 0.35;
    }
    &::-moz-placeholder {
      opacity: 0.35;
    }
    &:-ms-input-placeholder {
      opacity: 0.35;
    }
  }
`;